import { Component, OnInit, inject } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";

import { BtnActions, IconTypeEnum, TableColumnType,TableColumn } from "../../../common/interfaces/global-interfaces";
import { NotificationService } from "../../../services/notification.service";
import { SettingsService } from "../../../services/settings.service";
import { LayoutService } from "../../../shared/components/app-layout/shared-layout/layout.service";
import { AppState } from "../../../store";
import { StoreItemActions } from "../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../store/entities/store-item/store-item.model";
import { GET_ALL_SYSTEM_USERS, DELETE_SYSTEM_USERS_MUTATION } from "../../../store/entities/user-management/system-user/user.graphql";
import { SystemUser } from "../../../store/entities/user-management/system-user/user.model";
import { AddPersonReadersComponent } from "../../readers-management/readers-list/add-person-readers/add-person-readers.component";
import { AssignDesignatinComponent } from "../../setting-management/designation/assign-designatin/assign-designatin.component";
import { AssignRoleComponent } from "../../user-management/assign-user-role/assign-role.component";
import { AssignUserToSectionComponent } from "../../user-management/assign-user-to-section/assign-user-to-section.component";


@Component({
  selector: 'app-corporate-readers',
  templateUrl: './corporate-readers.component.html',
  styleUrl: './corporate-readers.component.scss'
})
export class CorporateReadersComponent implements OnInit {
  private  readonly router = inject(Router);

  private readonly settings = inject(SettingsService);
  private readonly notify = inject(NotificationService);
  private readonly store = inject(Store<AppState>);
  layoutService = inject(LayoutService);

  title = 'Personal Readers';
  addPermission: string[] = ['NO_PERMISSION'];
    additionalVariables = { userTypes: "CORPORATE" };

 query = GET_ALL_SYSTEM_USERS;
  upsertAction = StoreItemActions.upsertStoreItem;
  deleteAction = StoreItemActions.deleteStoreItem;
  storeEntity: StoreItemEntity = StoreItemEntity.user;

  viewDetails = false;
  viewDetailsTitle = 'Add / Edit User';

  tableColumns: TableColumn[];
  tableActions: BtnActions[] = [
    {
      id: 'more',
      title: 'More',
      permissions: ['NO_PERMISSION'],
      icon: 'more_horiz',
      iconType: IconTypeEnum.MATERIAL,
      children: [
        { id: 'edit', title: 'Edit', permissions: ['NO_PERMISSION'], icon: 'create', iconType: IconTypeEnum.MATERIAL },
        { id: 'delete', title: 'Delete', permissions: ['NO_PERMISSION'], icon: 'delete', iconType: IconTypeEnum.MATERIAL },
        // { id: 'assign', title: 'Assign to Designation', permissions: ['NO_PERMISSION'], icon: 'assignment', iconType: IconTypeEnum.MATERIAL },
        // { id: 'assignSection', title: 'Assign to Section', permissions: ['NO_PERMISSION'], icon: 'assignment', iconType: IconTypeEnum.MATERIAL },
        //  { id: 'assignRole', title: 'Assign to Role', permissions: ['NO_PERMISSION'], icon: 'assignment', iconType: IconTypeEnum.MATERIAL }


      ]
    }
  ];

  // store selected users for assignment
  selectedUserUuids: string[] = [];

  ngOnInit() {
    this.tableColumns = [
      { keyword: '', title: 'SN', type: TableColumnType.index },
      { keyword: 'firstName', title: 'First Name', sortableColumn: 'firstName' },
      { keyword: 'lastName', title: 'Last Name', sortableColumn: 'lastName' },
      { keyword: 'email', title: 'Email', sortableColumn: 'email' },
      { keyword: 'phone', title: 'Phone', sortableColumn: 'phone' },
      { keyword: 'role.roleName', title: 'Role', sortableColumn: 'role.roleName' },
   { keyword: 'designation.title', title: 'Designation', sortableColumn: 'designation.title' },
      { keyword: 'actions', title: 'Action', isActionColumn: true },

      
    ];

    
  }

  trackByUuid = (_: number, item: SystemUser) => item.uuid;



   onView(user: SystemUser) {
    this.router.navigate(['manage','user-management','user-list', user.uuid]);}
  
  onAdd(user?: SystemUser) {
    this.settings.openDialogModal({
      component: AddPersonReadersComponent,
      data: { user }
    });
  }

  btnClicked(ev: { id: string, data: SystemUser }) {
    if (!ev?.data) return;

    switch (ev.id) {
      case 'edit': this.onAdd(ev.data); break;
      case 'delete': this.onDelete(ev.data); break;
      case 'assign': this.onAssign(ev.data); break; 
      case 'assignSection': this.onAssignToSector(ev.data); break; // single user assignment
      case 'assignRole': this.onAssignToRole(ev.data); break; // single user assignment


    }
  }

  onDelete(user: SystemUser) {
    this.notify.confirmation({ message: 'Are you sure you want to delete this user?' }).then(ok => {
      if (!ok) return;

      this.store.dispatch(
        StoreItemActions.removeStoreItem({
          entity: this.storeEntity,
          mutation: DELETE_SYSTEM_USERS_MUTATION,
          input: { uniqueId: user.uuid },
          id: user.uuid
        })
      );
    });
  }

  // assign selected users to a designation
  onAssign(user?: SystemUser) {
    this.settings.openDialogModal({
      component: AssignDesignatinComponent,
      data: { user }
    });
  }

   onAssignToRole(user?: SystemUser) {
    this.settings.openDialogModal({
      component: AssignRoleComponent,
      data: { user }
    });
  }

    // assign selected users to a designation
  onAssignToSector(user?: SystemUser) {
    this.settings.openDialogModal({
      component: AssignUserToSectionComponent,
      data: { user }
    });
  }
  
mapUserData = (user: SystemUser) => {
  return {
    ...user,
    role: {
      roleName: user.roles?.length
        ? user.roles.map(r => r.displayName).join(', ')
        : 'N/A'
    },
    designation: {
      title: user.designation?.title || 'N/A'
    },
    phone: user.phone || '-',
    email: user.email || '-'
  };
};


  closePanel() {
    this.viewDetails = false;
    this.layoutService.closePanel();
  }
}
